const getters = {
  getAllCountries(state) {
    return state.countries;
  },
};

export default getters;
